import { Scenario } from "../Scenario/Scenario";

export class Budget extends Scenario {
    constructor(props) {
        super(props);
        this.props = props;
    }
}
